import React from 'react';
import { Shield } from 'lucide-react';
export function GuaranteeBadge() {
  return <div className="inline-flex items-center gap-2 bg-green-50 border border-green-200 rounded-full px-4 py-2 text-sm" data-id="element-87">
      <Shield size={16} className="text-green-600" data-id="element-88" />
      <span className="font-semibold text-green-900" data-id="element-89">
        30-Day Money-Back Guarantee
      </span>
    </div>;
}